import "./AutoRecharge.scss";

import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

import { CheckIcon } from "../../../../components/icons";
import type { IBillingSettingsWithValues } from "../../../../hooks/reactQueryHooks/useBilling";
import { useBillingSettings } from "../../../../hooks/reactQueryHooks/useBilling";
import { formatCurrency } from "../../../../utils/NumbersFormatting";
import { AutoRechargeModal } from "./AutoRechargeModal";

interface AutoRechargeProps {
  organization: string;
  accBallance: number;
  setLowBallanceThreshhold: (value: number) => void;
}

const AutoRecharge: React.FC<AutoRechargeProps> = ({
  organization,
  accBallance,
  setLowBallanceThreshhold,
}) => {
  const [showModal, setShowModal] = useState(false);

  const { data, refetch } = useBillingSettings(organization);
  const {
    isAutoChargeEnabled,
    expectedAmountOnTheAccount,
    lowCreditBalanceThreshold,
    chargeWhen,
  } = data || {};
  const openModal = () => setShowModal(true);
  const hideModal = () => setShowModal(false);

  useEffect(() => {
    if (lowCreditBalanceThreshold) {
      setLowBallanceThreshhold(lowCreditBalanceThreshold);
    }
  }, [lowCreditBalanceThreshold, setLowBallanceThreshhold]);

  return (
    <>
      <h4 className="billing-table-title">
        Auto recharge is {isAutoChargeEnabled ? "on" : "off"}
        {isAutoChargeEnabled && <CheckIcon />}
      </h4>
      {isAutoChargeEnabled ? (
        <p className="subscription-info-descr">
          When your credit balance goes below {formatCurrency(chargeWhen || 0)},
          your payment method will be charged to bring the balance up to{" "}
          {formatCurrency(expectedAmountOnTheAccount || 0)}.
        </p>
      ) : (
        <p className="subscription-info-descr">
          When your credit balance reaches $0, your CogCache Proxy API requests
          will stop working. Enable the auto recharge to automatically keep your
          credit balance topped up.
        </p>
      )}
      <Button variant="secondary" onClick={openModal}>
        {isAutoChargeEnabled ? "Change auto recharge" : "Enable auto charge"}
      </Button>

      {showModal && (
        <AutoRechargeModal
          organization={organization}
          settings={data || ({} as IBillingSettingsWithValues)}
          accBallance={accBallance}
          hideModal={hideModal}
          refetch={refetch}
        />
      )}
    </>
  );
};

export { AutoRecharge };
